import request from '../../utils/request'
import config from '../../../config/config'
const baseURL = config.baseUrl

//  信息新增
export function shopAdd (data) {
  return request({
    url: baseURL + 'shop/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function shopList (data) {
  return request({
    url: baseURL + 'shop/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function shopDelete (data) {
  return request({
    url: baseURL + 'shop/delete',
    method: 'post',
    data: data
  })
}
//  信息修改
export function shopUpdate (data) {
  return request({
    url: baseURL + 'shop/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/shop/index.js